/* eslint-disable camelcase */

import type { CdiSyncJob } from "@dashboardApi/apis/integrationsDirectCdiJobsJobId";
import type { BaseTableResultItem, TableResult } from "@tanstack/react-table";

export interface IntegrationsDirectCdiJobsParams {
  /** the unique identifier for the current app group */
  appGroupId: string;
  /** the query object containing all the filters */
  query?: Partial<Record<string, string | string[]>>;
  /** the groupby column */
  groupby?: string;
  /** the number of records to return per page */
  limit?: number;
  /** the column on which to sort */
  sortby?: string;
  /** the direction in which to sort */
  sortdir?: -1 | 1;
  /** the index for the first record in the set among the entire response */
  start?: number;
}

export const jobSyncStatusValues = <const>[
  "config_error",
  "partial",
  "running",
  "error",
  "success",
  "limit_exceeded",
];

export const originalJobSyncStatusValues = <const>[
  "started",
  "syncing",
  "synced",
  "ingesting",
  "ingested",
  "complete",
  "error",
  "sync_error",
  "ingest_error",
  "source_error",
  "sink_error",
  "running",
  "config_error",
  "limit_exceeded",
];

export type JobSyncStatus = (typeof jobSyncStatusValues)[number];

export type OriginalJobSyncStatus = (typeof originalJobSyncStatusValues)[number];

export interface CdiJobsResultsItem extends CdiSyncJob, BaseTableResultItem {}

export type CdiJobsResults = TableResult<CdiJobsResultsItem>;
